import {
  LOAD_ACCOMMODATION_REQUESTS,
  LOAD_ACCOMMODATION_REQUESTS_SUCCESS,
  LOAD_ACCOMMODATION_REQUESTS_ERROR,
  LOAD_ACCOMMODATION_REQUEST_DETAIL,
  LOAD_ACCOMMODATION_REQUEST_DETAIL_SUCCESS,
  LOAD_ACCOMMODATION_REQUEST_DETAIL_ERROR,
  LOAD_ACCOMMODATION_REQUEST_HISTORY,
  LOAD_ACCOMMODATION_REQUEST_HISTORY_SUCCESS,
  LOAD_ACCOMMODATION_REQUEST_HISTORY_ERROR,
  LOAD_ACCOMMODATION_PLAN,
  LOAD_ACCOMMODATION_PLAN_SUCCESS,
  LOAD_ACCOMMODATION_PLAN_ERROR,
  SUBMIT_ACCOMMODATION_REQUEST,
  SUBMIT_ACCOMMODATION_REQUEST_SUCCESS,
  SUBMIT_ACCOMMODATION_REQUEST_ERROR,
  UPLOAD_ACCOMMODATION_DOCUMENT,
  UPLOAD_ACCOMMODATION_DOCUMENT_SUCCESS,
  UPLOAD_ACCOMMODATION_DOCUMENT_ERROR,
  DOWNLOAD_ACCOMMODATION_LETTER,
  DOWNLOAD_ACCOMMODATION_LETTER_SUCCESS,
  DOWNLOAD_ACCOMMODATION_LETTER_ERROR,
  LOAD_ACCOMMODATION_TYPES,
  LOAD_ACCOMMODATION_TYPES_SUCCESS,
  LOAD_ACCOMMODATION_TYPES_ERROR,
  RESET_ACCOMMODATION_STATE,
  CLEAR_ACCOMMODATION_REQUEST_DETAIL,
} from "./types";

const initialState = {
  requests: {
    data: [],
    loading: false,
    error: null,
  },
  requestDetail: {
    data: null,
    loading: false,
    error: null,
  },
  requestHistory: {
    data: [],
    loading: false,
    error: null,
  },
  accommodationPlan: {
    data: null,
    loading: false,
    error: null,
  },
  submitting: false,
  submissionError: null,
  uploading: false,
  uploadError: null,
  downloading: false,
  downloadError: null,
  accommodationTypes: {
    data: [],
    loading: false,
    error: null,
  },
};

const studentAccommodationsReducer = (state = initialState, action) => {
  switch (action.type) {
    // Requests list
    case LOAD_ACCOMMODATION_REQUESTS:
      return {
        ...state,
        requests: { ...state.requests, loading: true, error: null },
      };
    case LOAD_ACCOMMODATION_REQUESTS_SUCCESS:
      return {
        ...state,
        requests: { data: action.payload, loading: false, error: null },
      };
    case LOAD_ACCOMMODATION_REQUESTS_ERROR:
      return {
        ...state,
        requests: { ...state.requests, loading: false, error: "Failed to load requests" },
      };

    // Request detail
    case LOAD_ACCOMMODATION_REQUEST_DETAIL:
      return {
        ...state,
        requestDetail: { ...state.requestDetail, loading: true, error: null },
      };
    case LOAD_ACCOMMODATION_REQUEST_DETAIL_SUCCESS:
      return {
        ...state,
        requestDetail: { data: action.payload, loading: false, error: null },
      };
    case LOAD_ACCOMMODATION_REQUEST_DETAIL_ERROR:
      return {
        ...state,
        requestDetail: { ...state.requestDetail, loading: false, error: "Failed to load request detail" },
      };

    // Request history
    case LOAD_ACCOMMODATION_REQUEST_HISTORY:
      return {
        ...state,
        requestHistory: { ...state.requestHistory, loading: true, error: null },
      };
    case LOAD_ACCOMMODATION_REQUEST_HISTORY_SUCCESS:
      return {
        ...state,
        requestHistory: { data: action.payload, loading: false, error: null },
      };
    case LOAD_ACCOMMODATION_REQUEST_HISTORY_ERROR:
      return {
        ...state,
        requestHistory: { ...state.requestHistory, loading: false, error: "Failed to load history" },
      };

    // Accommodation plan
    case LOAD_ACCOMMODATION_PLAN:
      return {
        ...state,
        accommodationPlan: { ...state.accommodationPlan, loading: true, error: null },
      };
    case LOAD_ACCOMMODATION_PLAN_SUCCESS:
      return {
        ...state,
        accommodationPlan: { data: action.payload, loading: false, error: null },
      };
    case LOAD_ACCOMMODATION_PLAN_ERROR:
      return {
        ...state,
        accommodationPlan: { ...state.accommodationPlan, loading: false, error: "Failed to load plan" },
      };

    // Submit request
    case SUBMIT_ACCOMMODATION_REQUEST:
      return {
        ...state,
        submitting: true,
        submissionError: null,
      };
    case SUBMIT_ACCOMMODATION_REQUEST_SUCCESS:
      return {
        ...state,
        submitting: false,
        requestDetail: { data: action.payload, loading: false, error: null },
        requests: {
          ...state.requests,
          data: [action.payload, ...state.requests.data],
        },
      };
    case SUBMIT_ACCOMMODATION_REQUEST_ERROR:
      return {
        ...state,
        submitting: false,
        submissionError: "Failed to submit request",
      };

    // Upload document
    case UPLOAD_ACCOMMODATION_DOCUMENT:
      return {
        ...state,
        uploading: true,
        uploadError: null,
      };
    case UPLOAD_ACCOMMODATION_DOCUMENT_SUCCESS:
      return {
        ...state,
        uploading: false,
        requestDetail: {
          ...state.requestDetail,
          data: {
            ...state.requestDetail.data,
            documents: [
              ...(state.requestDetail.data?.documents || []),
              action.payload,
            ],
          },
        },
      };
    case UPLOAD_ACCOMMODATION_DOCUMENT_ERROR:
      return {
        ...state,
        uploading: false,
        uploadError: "Failed to upload document",
      };

    // Download letter
    case DOWNLOAD_ACCOMMODATION_LETTER:
      return {
        ...state,
        downloading: true,
        downloadError: null,
      };
    case DOWNLOAD_ACCOMMODATION_LETTER_SUCCESS:
      return {
        ...state,
        downloading: false,
      };
    case DOWNLOAD_ACCOMMODATION_LETTER_ERROR:
      return {
        ...state,
        downloading: false,
        downloadError: "Failed to download letter",
      };

    // Accommodation types
    case LOAD_ACCOMMODATION_TYPES:
      return {
        ...state,
        accommodationTypes: { ...state.accommodationTypes, loading: true, error: null },
      };
    case LOAD_ACCOMMODATION_TYPES_SUCCESS:
      return {
        ...state,
        accommodationTypes: { data: action.payload, loading: false, error: null },
      };
    case LOAD_ACCOMMODATION_TYPES_ERROR:
      return {
        ...state,
        accommodationTypes: { ...state.accommodationTypes, loading: false, error: "Failed to load accommodation types" },
      };

    // Reset state
    case RESET_ACCOMMODATION_STATE:
      return initialState;

    // Clear detail
    case CLEAR_ACCOMMODATION_REQUEST_DETAIL:
      return {
        ...state,
        requestDetail: { data: null, loading: false, error: null },
      };

    default:
      return state;
  }
};

export default studentAccommodationsReducer;
